//basic
import React from 'react'
import { inject, observer } from 'mobx-react'

//style
import '../monitoring/Monitoring.scss'

//api
import { api } from '../../../../functions/api'

//custom components
import CustomInput from '../../../../components/basic/input'

//material-ui
import { CircularProgress, Card, CardContent } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiClose } from '@mdi/js'

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class Monitoring extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      changeParameterValues: false,
      idParam: 0,
      
      links: [],
      link: '',
    }
  }
  
  timeout = null
  links = []
  
  componentDidMount() {
    this.loadBasicData()
  }
  
  loadBasicData = async () => {
    this.setState({ loading: true })
    let load_data = await api({
      method: 'get',
      url: 'products/' + this.props.routerData.match.params.idProduct,
      authorization: this.props.internal.user.access_token,
    })
    
    if (load_data.success && load_data.success === true) {
      this.setState({
        links: load_data.data.data.monitored_links,
        loading: false,
      })
    }
  }
  
  handleNewLink = () => {
    console.log({ link: this.link.state.value })
    this.setState({
      link: this.link.state.value,
    })
  }
  
  handleDeleteLink = (index) => {
    this.links[index].setValue('', () => this.storeLinks());
  }
  
  storeLinks = (withNew = false) => {
    this.setState({loading: true})
    api({
      method: 'patch',
      url: 'products/' + this.props.routerData.match.params.idProduct + '/store-links',
      authorization: this.props.internal.user.access_token,
      params: {
        links: [
          ...this.links.map(item => item.state.value),
          withNew ? this.state.link : undefined
        ]
      }
    }).then(result => {
      if (result.success) {
        this.setState({
          links: result.data.data.monitored_links,
          link: '',
          loading: false,
        })
        this.link.setValue('')
        this.links = this.links.filter(item => item)
      }
    })
  }
  
  render() {
    
    const { loading, links } = this.state
    
    if (loading) {
      return <CircularProgress className={'circular-progress'}/>
    }
    
    return <Card className={'links-card'}>
      <CardContent className={'links-card-content'}>
        <div>
          <CustomInput
            ref={ref => this.link = ref}
            text={this.props.translate.i18n.MODULES['PRODUCTS'].MONITORING.NEW_LINK}
            value={this.state.link}
            id={'link'}
            pressedButton
            onPressButton={() => this.storeLinks(true)}
            change={this.handleNewLink}
            className={'w-100'}
          />
        </div>
        {links.length === 0 && <div><em>{this.props.translate.i18n.MODULES.PRODUCTS.MONITORING.NO_LINKS}</em></div>}
        {links.map((item, index) => <div className={'flex'}>
          <CustomInput
            ref={ref => this.links[index] = ref}
            text={this.props.translate.i18n.MODULES['PRODUCTS'].MONITORING.LINK}
            value={item.link}
            id={`link-index`}
            key={item.link}
            pressedButton
            onPressButton={() => this.storeLinks()}
            className={'w-100'}
            />
          <div className={'delete'} onClick={() => this.handleDeleteLink(index)}>
            <Icon path={mdiClose} size={1} />
          </div>
        </div>)}
      </CardContent>
    </Card>
  }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/monitoring/Monitoring.js